import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useRef } from "react";
import { ErrorResponse, MessageErrorResponse } from "../../../requests/@types";
import { AnalysisStatus } from "../@types";
import api from "../api";

export const URL_DYNAMIC_ANALYSIS_STATUS_QUERY_KEY =
  "url_dynamic_analysis_status";

export const SUCCESS_STATUS = ["finished", "success"];

const REFETCH_INTERVAL = 10 * 1000; // 10 seconds

const useUrlDynamicAnalysisStatus = (url: string) => {
  const abortRef = useRef<AbortController | null>(null);

  const fetchFn = () => {
    abortRef.current?.abort();
    const abortController = new AbortController();
    abortRef.current = abortController;

    return api.urlDynamicAnalysisStatus(url, abortController.signal);
  };

  const query = useQuery<
    AxiosResponse<AnalysisStatus>,
    ErrorResponse<MessageErrorResponse>,
    AnalysisStatus
  >({
    queryKey: [URL_DYNAMIC_ANALYSIS_STATUS_QUERY_KEY, url],
    queryFn: fetchFn,
    select: ({ data }) => data,
    enabled: Boolean(url),
    refetchInterval: ({ state }) => {
      const { error, data } = state ?? {};
      // stop refetching when success or 404
      if (error?.status === 404) return false;
      if (SUCCESS_STATUS.includes(data?.data?.analysis_status ?? ""))
        return false;
      return REFETCH_INTERVAL;
    }
  });

  return query;
};

export default useUrlDynamicAnalysisStatus;
